/* eslint-disable no-undef */
import { web3 } from "./MintingInstance";

// Function to get wallet balance
export const getWalletBalance = async (address) => {
  try {
    if (!web3.utils.isAddress(address)) {
      console.error("Invalid Ethereum address:", address);
      return null;
    }
    const ethBalance = await web3.eth.getBalance(address);

    const formattedEthBalance = web3.utils.fromWei(ethBalance, "ether");

    return { ethBalance: formattedEthBalance };
  } catch (error) {
    console.error("Error fetching balances:", error.message || error);
  }
};

// export const getGasPrice = async () => {
//   let gasPrice = await web3.eth.getGasPrice();
//   const formattedGasPrice = web3.utils.fromWei(gasPrice, "ether");
//   return (formattedGasPrice * 1.5).toString();
// }

export const getGasPrice = async () => {
  let gasPrice = await web3.eth.getGasPrice();
  return (BigInt(gasPrice) * BigInt(200)) / BigInt(100); 
};

